import { createContext, useContext } from "react";

const PortalContainerContext = createContext<HTMLElement | null>(null);

const PortalContainerProvider = PortalContainerContext.Provider;

const usePortalContainer = () => useContext(PortalContainerContext);

export { PortalContainerProvider, usePortalContainer };
